<template>
	<div class="register_state_callback_table">
		<div>
			<template>
			    <el-table
				    :data="tableData"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="require"
					        label="是否必须"
					        width="200px">
				      	</el-table-column>
				      	<el-table-column
				        	prop="name"
				        	label="参数名"
                            width="200px">
				      	</el-table-column>
                        <el-table-column
				        	prop="type"
				        	label="类型"
                            width="200px">
				      	</el-table-column>
                          <el-table-column
				        	prop="msg"
				        	label="说明">
				      	</el-table-column>
			    </el-table>
			</template>
		</div>
	</div>
</template>
<script>
	export default{
		props: {
            propsTableData:null,
        },
		data(){
			return{
				// tableData:[
				// 	{"require":"0","name":'aaa',"type":"成功","msg":"成功"}
				// ],
				tableData:[],
			}
		},
		methods:{
			Trim(str){ 
					return str.replace(/(^\s*)|(\s*$)/g, ""); 
			}
		},
		mounted(){
			if (this.propsTableData) {
				for(var i=0;i<this.propsTableData.length;i++){
					console.log(this.propsTableData[i].msg)
					this.propsTableData[i].msg =this.Trim(this.propsTableData[i].msg)
				}
				this.tableData = this.propsTableData;
			}
			
		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../less/index.less';
	.register_state_callback_table{
		//margin:5px 0 30px 30px;
		margin:5px 0 30px 0;
		thead{
			tr{
				th{
					padding:15px 0;
					background: #F5F7FA;
					color:#333;
				}
			}
			
		}
		.cell{
			text-align: center;
			color:#2c3e50;;
			.table_msg{
				text-align: left;
			}
		}
		tbody{
			td{
				padding:8px 0;
			}
		}	
		
	}
</style>	


// WEBPACK FOOTER //
// src/components/frmRequestParamsTable.vue